import { render, staticRenderFns } from "./SuperadminPage.vue?vue&type=template&id=2a17f971&scoped=true&"
import script from "./SuperadminPage.vue?vue&type=script&lang=js&"
export * from "./SuperadminPage.vue?vue&type=script&lang=js&"
import style0 from "./SuperadminPage.vue?vue&type=style&index=0&id=2a17f971&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a17f971",
  null
  
)

export default component.exports